import React, { useState } from "react";
import {
  Box,
  Card,
  Typography,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
} from "@mui/material";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import DescriptionIcon from "@mui/icons-material/Description";
import PersonIcon from "@mui/icons-material/Person";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import BankingIntegrationModal from "../expenses-budgets/BankingIntegrationModal";

const IntegrationPrompts = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedIntegration, setSelectedIntegration] = useState(null);

  const integrations = [
    {
      id: "banking",
      title: "Banking Integration",
      description: "Connect your bank accounts for automatic progress tracking",
      icon: <AccountBalanceIcon />,
      benefits: [
        "Automatic goal progress tracking",
        "Real-time cash flow monitoring",
        "Smart recommendations based on spending patterns",
      ],
    },
    {
      id: "estate",
      title: "Estate Planning",
      description: "Create or link your estate plan",
      icon: <DescriptionIcon />,
      benefits: [
        "Ensure your goals align with estate planning",
        "Coordinate with legal professionals",
        "Regular plan reviews and updates",
      ],
    },
    {
      id: "tax",
      title: "Tax Professional",
      description: "Connect with a tax professional",
      icon: <PersonIcon />,
      benefits: [
        "Tax-efficient goal planning",
        "Professional guidance on deductions",
        "Coordinated tax strategy",
      ],
    },
  ];

  const handleToggle = (integration) => {
    setSelectedIntegration(integration);
    setOpenDialog(true);
  };

  return (
    <Card className="mt-6 p-4">
      <Typography variant="h6" className="mb-4">
        Available Integrations
      </Typography>

      <List>
        {integrations.map((integration) => (
          <ListItem
            key={integration.id}
            className="hover:bg-gray-50 dark:hover:bg-gray-800 rounded-lg transition-colors duration-150"
          >
            <ListItemIcon>{integration.icon}</ListItemIcon>
            <ListItemText
              primary={integration.title}
              secondary={integration.description}
            />
            <ListItemSecondaryAction>
              <Switch
                edge="end"
                onChange={() => handleToggle(integration)}
                checked={false}
              />
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>

      <Dialog
        open={Boolean(openDialog)}
        onClose={() => setOpenDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        {selectedIntegration && (
          <>
            <DialogTitle>Enable {selectedIntegration.title}</DialogTitle>
            <DialogContent>
              <Typography variant="subtitle1" className="mb-4">
                {selectedIntegration.description}
              </Typography>

              <Typography variant="subtitle2" className="mb-2 text-gray-700 dark:text-gray-300">
                Benefits:
              </Typography>
              <List>
                {selectedIntegration.benefits.map((benefit, index) => (
                  <ListItem key={index} dense>
                    <ListItemIcon>
                      <ArrowForwardIcon
                        className="text-blue-500"
                        fontSize="small"
                      />
                    </ListItemIcon>
                    <ListItemText primary={benefit} />
                  </ListItem>
                ))}
              </List>
            </DialogContent>
            <DialogActions className="p-4">
              <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
              <Button
                variant="contained"
                className="bg-blue-600"
                onClick={() => {
                  // Handle integration setup
                  setOpenDialog(false);
                }}
              >
                Set Up Integration
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </Card>
  );
};

export default IntegrationPrompts;
